import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Cookies from 'vue-cookies';
import ElementUI, { FormItem } from 'element-ui';
// 修复：el-form-item 未设置 prop 却添加了 required 时，会触发“undefined is required”的误导性报错。
// 统一拦截：没有 prop 的表单项不参与校验。
const _formItemValidate = FormItem.methods.validate;
FormItem.methods.validate = function (trigger, callback) {
  if (!this.prop) {
    if (typeof callback === 'function') {
      callback();
    }
    return true;
  }
  return _formItemValidate.apply(this, arguments);
};
import QuillEditor from 'vue-quill-editor';
import Upload from './components/upload.vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import 'element-ui/lib/theme-chalk/index.css';
import '@/font/iconfont.css';
import '@/fontchoose/iconfont.css';
import '@/color-font/iconfont.css'
import '@/color-font/iconfont.js'
import '@/style/overall.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import common from '@/utils/common';
import axios from 'axios';

axios.interceptors.response.use(function (response) {
  return response;
}, (error) => {
  let status = error.response.status;
  if (status == 401) { // 登录过期，跳转到登录页面
    store.commit("tabs/removeAll");
    Cookies.remove("user");
    router.replace({
      name: "login"
    });
  }
})

Vue.use(ElementUI);
Vue.use(Cookies);
Vue.use(common);
Vue.use(QuillEditor);
Vue.component('upload', Upload);
Vue.component('vue-qrcode', VueQrcode);

Vue.prototype.$notifySuccess = (title, msg, duration, isHTML) => {
  let options = {
    type: "success",
    title: title,
    message: msg,
    position: 'bottom-right'
  }
  if (duration === 0 || duration) {
    options.duration = duration;
  }
  if (isHTML) {
    options.dangerouslyUseHTMLString = true;
  }
  ElementUI.Notification(options);
}

Vue.prototype.$notifyError = (title, msg, duration, isHTML) => {
  let options = {
    type: "error",
    title: title,
    message: msg,
    position: 'bottom-right'
  };
  if (duration === 0 || duration) {
    options.duration = duration;
  }
  if (isHTML) {
    options.dangerouslyUseHTMLString = true;
  }
  ElementUI.Notification(options);
}

Vue.prototype.$notifySystemEx = (err) => {
  ElementUI.Notification({
    type: "error",
    title: "未知异常",
    message: JSON.stringify(err),
    position: 'bottom-right'
  });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js